<template>
  <div :id="this.identity"
       class="modal fade reactive-gift-choice--modal"
       tabindex="-1"
       role="dialog"
       aria-labelledby="ReactiveGiftChoiceModalLabel"
       aria-hidden="true">
    <div class="modal-dialog reactive-gift-choice--modal-dialog" role="document">
      <div class="modal-content reactive-gift-choice--content">
        <div class="modal-header reactive-gift-choice--content-header">
          <div class="modal-header-wrapper">
            <h5 class="modal-title col-12" id="ReactiveGiftChoiceModalLabel">{{ t('modal.title', { namespace: 'giftSelection' }) }}</h5>
            <span class="modal-title-sub col-12">{{ t('modal.subtitle', { namespace: 'giftSelection' }) }}</span>
          </div>
        </div>
        <div class="modal-body reactive-gift-choice--content-body">
          <adv-cart-gift-list :enable-picker="true"
                              :styling-options="stylingOptions"
                              :gift-choices-filter="filterGiftsWithChoice"></adv-cart-gift-list>
        </div>
        <div class="modal-footer reactive-gift-choice--content-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{
              t('modal.action.cancel', { namespace: 'giftSelection' }) }}</button>
          <button type="button" class="btn btn-success" @click="confirmCheckout">{{
              t('modal.action.submit', { namespace: 'giftSelection' }) }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdvCartGiftList from './AdvCartGiftList'
import giftChoiceMixin from './mixins/giftChoiceMixin'
export default {
  name: 'AdvGiftChoiceModal',
  components: {
    AdvCartGiftList
  },
  mixins: [giftChoiceMixin],
  props: {
    identity: {
      type: String,
      required: false,
      default: 'GiftChoiceModal'
    },
    formSubmitHandle: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      stylingOptions: {
        items: 'col-6 col-sm-4 col-md-12'
      }
    }
  },
  computed: {
    submitButton: function () {
      const submitButtonNodes = document.getElementsByName(this.formSubmitHandle)
      if (submitButtonNodes.length < 1) {
        throw new Error(
          `Unable to find form submit button using handle '${this.formSubmitHandle}'.` +
          'Possible causes: ' +
          'Prop form-submit-handle was supplied with invalid value; Submit button isn\'t rendered; Form isn\'t rendered'
        )
      }
      return submitButtonNodes[0]
    },
    submissionForm: function () {
      return this.submitButton.form
    }
  },
  methods: {
    confirmCheckout: function () {
      this.submitButton.click()
    }
  }
}
</script>
